export const initUiToggle = () => {
  document.querySelectorAll(".ui-toggle").forEach(function(theSwitch) {
    theSwitch.addEventListener("click", handleClickEvent, false);
  });
};

function handleClickEvent(evt) {
  let el = evt.target;

  if (el.getAttribute("aria-checked") == "true") {
    el.setAttribute("aria-checked", "false");
  } else {
    el.setAttribute("aria-checked", "true");
  }
}
